import { __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { callback } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import { HuaWeiSDK } from '@ekuaibao/sdk-bridge/sdk/huawei';
import registerAPI from '../registerAPI';
import { initializeTitle } from '../initializeTitle';
import initPlatformInfo from '../initPlatformInfo';
import registerHandler from '../registerHandler';
import { fetchHandleError } from '../FetchConfig';
import { initRoute } from '../initRoute';
import { initColors } from '../initColors';
import setNetworkAdapter from '../setNetworkAdapter';
import initLogger from '../../logger/initLogger';
initLogger();
window.__PLANTFORM__ = 'HUAWEI';
function startup() {
    app.use({
        id: '@app',
        onready: function () {
            addNcpcCode();
        }
    });
    callback();
}
function unAuthorizedAction(error) {
    if (error.status === 401) {
        location.replace(window.HUAWEI_LOGIN);
    }
}
fetchHandleError(unAuthorizedAction);
export function bootstrap() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initColors();
                    app.container.set('IDeviceType', 'DESKTOP');
                    app.container.set('ISMessageEntry', false);
                    app.sdk = app.container.get(HuaWeiSDK);
                    registerHandler();
                    return [4, app.sdk.initialize()];
                case 1:
                    _a.sent();
                    initRoute();
                    initPlatformInfo();
                    return [4, newHomeConfig()];
                case 2:
                    _a.sent();
                    initializeTitle();
                    registerAPI();
                    startup();
                    setNetworkAdapter();
                    return [2];
            }
        });
    });
}
